export const designHome = {
  choiceness: '精选案例',
  viewCollect: '仅看收藏',
  style: '风格',
  space: '空间',
  plan: '户型',
  area: '面积',
  excellent: '优秀设计',
  // options
  unlimited: '不限',
  newChineseStyle: '新中式',
  chineseStyle: '中式',
  stylish: '现代',
  nordic: '北欧',
  newClassical: '新古典',
  American: '美式',
  postModern: '后现代',
  industrial: '工业风',
  europeanClassical: '欧式古典',
  SoutheastAsia: '东南亚',
  French: '法式',
  Mediterranean: '地中海',
  Mediterranean: '地中海',
  Japanese: '日式',
  others: '其他',
  drawingRoom: '客厅',
  corridor: '走廊',
  diningRoom: '餐厅',
  masterBedroom: '主卧',
  children: '儿童房',
  schoolroom: '书房',
  kitchen: '厨房',
  toilet: '卫生间',
  multifunctional: '多功能室',
  secondary: '次卧',
  guest: '客卧',
  oldPerson: '老人房',
  balcony: '阳台',
  hallways: '玄关',
  bedroom: '卧室',
  lobby: '门厅',
  storage: '储物间',
  bedroom1: '一居',
  bedroom2: '两居',
  bedroom3: '三居',
  bedroom4: '四居',
  bedroom5: '五居及以上',
  less60: '60㎡以下',
  greater130: '130㎡以上',
  position: '位置'
};
